import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/store';
import { Admin } from '@/types/admin';

const itemsSelector = (state: RootState) =>
  state.organization.affiliation.items;

export const activeAdmins = createSelector(itemsSelector, (items): Admin[] =>
  items.filter((item) => item.admin.activatedAt).map((item) => item.admin),
);
